import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetProviderNames,
	GetProviderNamesParams,
	GetProviderNamesResponse,
} from 'domain/usecases/private/booking-flow/health-V1/get-health-provider-names';

export class RemoteGetHealthProviderNames implements GetProviderNames {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetProviderNamesResponse>,
	) {}

	async get({signal, ...params}: GetProviderNamesParams): Promise<GetProviderNamesResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
